import { indexAuthoringTasksInSchedule } from "authoring/routes/project/schedule-editor/lib/index-authoring-tasks-in-schedule"

export function restoreDraftSnapshotInPlace(targetDraft, snapshot) {
    if (!targetDraft || !snapshot) return null

    const restored = cloneSnapshot(snapshot)
    for (const key of Object.keys(targetDraft)) {
        delete targetDraft[key]
    }

    Object.assign(targetDraft, restored)
    indexAuthoringTasksInSchedule(targetDraft)
    return targetDraft
}

function cloneSnapshot(snapshot) {
    if (typeof structuredClone === "function") {
        return structuredClone(snapshot)
    }

    return JSON.parse(JSON.stringify(snapshot))
}
